export default {
  isHebrew(str: string): boolean {
    const lettersAndNumbersOnly = new RegExp('^[א-ת0-9 ]*$')
    return !!str.match(lettersAndNumbersOnly);
  },
}
